/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Observable from '../../Observable/Observable';
import ChildComponent from '../ChildComponent';
import { ISelectItem } from './ISelectItem';
import SelectListViewModel from './SelectListViewModel';
import ComponentBase from '../../ComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default class SelectListItemViewModel<T> extends ChildComponent<SelectListViewModel<T>> implements ISelectItem<T>
{
    @property()
    public ItemId: string = '';

    public Item: T = null;

    private _displayNameObservable: Observable<string> = new Observable<string>('');
    @property()
    public get DisplayName(): string { return this._displayNameObservable.Value; }
    public set DisplayName(value: string) { this._displayNameObservable.Value = value; }

    // #region UI

    @property(cc.Label)
    protected displayNameLabel: cc.Label = null;

    /** @hidden */
    protected onLoad(): void
    {
        this._displayNameObservable.OnChanged(() => this.updateUI());

        this.node.on(cc.Node.EventType.TOUCH_END, ((event: cc.Event.EventCustom) =>
        {
            ComponentBase.CancelEventHandler(event);
            this.Parent.Selected = this;
        }).bind(this));
    }

    protected start(): void
    {
        this.updateUI();
    }

    /** Update UI to current values. */
    private updateUI = (): void =>
    {
        this.displayNameLabel.string = this._displayNameObservable.Value;
    }

    public UpdateModel(item: ISelectItem<T>): void
    {
        this.ItemId = item.ItemId;
        this.Item = item.Item;
        this.DisplayName = item.DisplayName;
    }

    // #endregion
}
